import { all } from 'redux-saga/effects'

import { exportSaga } from './export/sagas'

export function* jobApplicationSaga() {
  yield all([exportSaga()])
}
